import { FormattedMessage, useIntl } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';
import { usePinScreenSettings } from '../../context/PinScreenSettingsContext';
import { PinScreenSetting } from '../../hooks/usePinScreenSetting';

const PinScreenSettings = () => {
  const { pinScreenSetting } = usePinScreenSettings();
  const { formatMessage } = useIntl();
  const location = useLocation();
  const currentLocationId = location.pathname.split('/')[1]!;

  const settingDisplayName = () => {
    switch (pinScreenSetting().setting) {
      case PinScreenSetting.manually: {
        return formatMessage({ id: 'pinScreenSetting.manually' });
      }
      case PinScreenSetting.afterInactivePeriod: {
        return formatMessage({ id: 'pinScreenSetting.afterInactiveMinutes' });
      }
      case PinScreenSetting.afterEachSale: {
        return formatMessage({ id: 'pinScreenSetting.afterEachSale' });
      }
    }
  };

  return (
    <Link
      className="umami-context-menu-item border-b border-grey-lightest !py-3 !text-brand-black"
      to={`/${currentLocationId}/pin-settings`}
      state={{ backgroundLocation: location }}
    >
      <div className="flex w-full items-center justify-between">
        <FormattedMessage id="header.pinScreenSettings" />
        <span className="text-sm text-grey-dark">{settingDisplayName()}</span>
      </div>
    </Link>
  );
};

export default PinScreenSettings;
